export default __webpack_public_path__ + "static/media/AboutBG.19627894.jpg";